// extracted by mini-css-extract-plugin
module.exports = {"currentitem":"currentItem_currentitem__3lwSt","text":"currentItem_text__39HLA","items":"currentItem_items__1so4a"};